import type { RecurringPaymentAgreementRequest } from '../../../generated-types';
import { createRecurringPaymentAgreement } from '../../../services/recurringPaymentsService';
import nullableZonedDateToUtc from '../../../utils/mapper/nullableZonedDateToUtc';
import { RecurringTransferState } from './form/state';

export default () => (recurringTransferState: RecurringTransferState) => {
    const request: RecurringPaymentAgreementRequest = {
        fromAccountNumber: recurringTransferState.fromAccount!,
        toAccount: recurringTransferState.toAccount!,
        amount: recurringTransferState.amount!,
        currency: 'NOK',
        text: recurringTransferState.note,
        ownText: recurringTransferState.ownText,
        firstPaymentDate: nullableZonedDateToUtc(recurringTransferState.firstPaymentDate)!,
        lastPaymentDate: nullableZonedDateToUtc(recurringTransferState.lastPaymentDate),
        paymentType: 'TRANSFER',
        paymentInterval: recurringTransferState.paymentInterval!,
        deviceId: window.ReactNativeProps?.deviceId,
    };

    return createRecurringPaymentAgreement(request);
};
